/* Copyright (c) 2021 Paul Nebel */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Icon from './icon';

const Svg = styled(Icon)` 
    width: 30px; 
    height: 30px;
`;

const LogoSmall = ({ className, color }) => ( 
    <Svg viewBox="0, 0, 203, 316" className={className}>   
        <g id="Layer_1">
            <g>
                <path d="M52.5,104.5 C80.114,104.5 102.5,120.17 102.5,139.5 C102.5,158.83 80.114,174.5 52.5,174.5 C24.886,174.5 1.5,158.83 1.5,139.5 C1.5,120.17 24.886,104.5 52.5,104.5 z" fill={ color }/>
                <path d="M52.5,104.5 C80.114,104.5 102.5,120.17 102.5,139.5 C102.5,158.83 80.114,174.5 52.5,174.5 C24.886,174.5 1.5,158.83 1.5,139.5 C1.5,120.17 24.886,104.5 52.5,104.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
            <g>
                <path d="M52.5,174.5 C80.114,174.5 102.5,190.17 102.5,209.5 C102.5,228.83 80.114,244.5 52.5,244.5 C24.886,244.5 1.5,228.83 1.5,209.5 C1.5,190.17 24.886,174.5 52.5,174.5 z" fill={ color }/>
                <path d="M52.5,174.5 C80.114,174.5 102.5,190.17 102.5,209.5 C102.5,228.83 80.114,244.5 52.5,244.5 C24.886,244.5 1.5,228.83 1.5,209.5 C1.5,190.17 24.886,174.5 52.5,174.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
            <g>
                <path d="M52.5,244.5 C80.114,244.5 102.5,260.17 102.5,279.5 C102.5,298.83 79.114,314.5 51.5,314.5 C23.886,314.5 1.5,298.83 1.5,279.5 C1.5,260.17 24.886,244.5 52.5,244.5 z" fill={ color }/>
                <path d="M52.5,244.5 C80.114,244.5 102.5,260.17 102.5,279.5 C102.5,298.83 79.114,314.5 51.5,314.5 C23.886,314.5 1.5,298.83 1.5,279.5 C1.5,260.17 24.886,244.5 52.5,244.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
            <g>
                <path d="M151.5,1.5 C179.114,1.5 201.5,17.17 201.5,36.5 C201.5,55.83 180.114,71.5 152.5,71.5 C124.886,71.5 102.5,55.83 102.5,36.5 C102.5,17.17 123.886,1.5 151.5,1.5 z" fill={ color }/>
                <path d="M151.5,1.5 C179.114,1.5 201.5,17.17 201.5,36.5 C201.5,55.83 180.114,71.5 152.5,71.5 C124.886,71.5 102.5,55.83 102.5,36.5 C102.5,17.17 123.886,1.5 151.5,1.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
            <g>
                <path d="M152.5,71.5 C180.114,71.5 201.5,87.17 201.5,106.5 C201.5,125.83 180.114,141.5 152.5,141.5 C124.886,141.5 102.5,125.83 102.5,106.5 C102.5,87.17 124.886,71.5 152.5,71.5 z" fill={ color }/>
                <path d="M152.5,71.5 C180.114,71.5 201.5,87.17 201.5,106.5 C201.5,125.83 180.114,141.5 152.5,141.5 C124.886,141.5 102.5,125.83 102.5,106.5 C102.5,87.17 124.886,71.5 152.5,71.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
            <g>
                <path d="M152.5,141.5 C180.114,141.5 201.5,157.17 201.5,176.5 C201.5,195.83 180.114,211.5 152.5,211.5 C124.886,211.5 102.5,195.83 102.5,176.5 C102.5,157.17 124.886,141.5 152.5,141.5 z" fill={ color }/>
                <path d="M152.5,141.5 C180.114,141.5 201.5,157.17 201.5,176.5 C201.5,195.83 180.114,211.5 152.5,211.5 C124.886,211.5 102.5,195.83 102.5,176.5 C102.5,157.17 124.886,141.5 152.5,141.5 z" fillOpacity="0" stroke={ color } strokeWidth="1"/>
            </g>
        </g>
    </Svg>
);


LogoSmall.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

LogoSmall.defaultProps = {
    color: 'black',
};

export default LogoSmall;



